import { useEffect } from "react";

export default function PageHead({ title, description }) {
  useEffect(() => {
    const base = "KYRA";
    document.title = title ? `${title} | ${base}` : `${base} — Securite alimentaire & anti-gaspillage`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
